import { CreatePolicyPayload, PolicyDTO } from '@practium/features/policy';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export function usePostPolicy() {
	const queryClient = useQueryClient();

	return useMutation<PolicyDTO, Error, CreatePolicyPayload>({
		mutationFn: async (data) => {
			try {
				return (await api.post('/management/policy-version/create', data)).data;
			} catch (error) {
				if (error instanceof Error) throw toApiError(error, 'Erro ao criar o termo.');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['policies', 'management'] });
		},
		onError: (error) => {
			console.error('Erro ao criar o termo:', getApiErrorMessage(error, 'Erro ao criar o termo.'));
		},
	});
}
